import React, { useState, useEffect } from 'react'
import css from '../css/gamehis.module.css'
import ReactPaginate from 'react-paginate'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { BsChatDots } from 'react-icons/bs'
// import Header from "../Components/Header";
import Rightcontainer from '../Components/Rightcontainer'
import axios from 'axios'
import socket from '../Components/socket'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import { toggleWidget } from 'react-chat-widget'
import { apiRequest } from '../../apiService/allApi'
import { Margin } from '@mui/icons-material'

const Gamehistory = ({ TicketList, Conversation }) => {
  // console.log(Conversation)
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 
  const [user, setUser] = useState()
  let limit = 50
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    // await axios
    //   .get(baseUrl+`me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers)
    // .then(res => {
    setUser(res.data)

    //Allgames(res.data._id)
    Allgames(res.data._id, pageNumber, limit)
    // window.location.reload()
    // })
  }

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)

  }
  const [game, setGame] = useState([])
  // console.log(game)

  const Allgames = async id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    setIsLoading(true)

    try {
      const res = await apiRequest(`game/history/user/${id}?page=${pageNumber}&_limit=${limit}`, "GET", null, headers)
      let gameHis = []
      res.data.data.forEach(ele => {
        if (
          ele.Status == 'completed' ||
          ele.Status == 'cancelled' ||
          ele.Status == 'conflict'
        ) {
          gameHis.push(ele)
        }
      })
      setGame(gameHis)
      setNumberOfPages(res.data.totalPages)
      setIsLoading(false)
    } catch (e) {
    }
  }

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };

  useEffect(() => {
    role()
    //eslint-disable-next-line
  }, [pageNumber, limit])


  // All history Api 

  // UserList

  const UserList = async id => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`)

    var urlencoded = new URLSearchParams()
    // urlencoded.append("agent_id", "63b5340bc5d2b82e4652b216");
    urlencoded.append('supportType', 'game')
    urlencoded.append('issue', id)

    const res = await apiRequest('chat/genrate-ticket', "POST", urlencoded, myHeaders)
    // .then(response => response.json())
    // toggleWidget()
    TicketList()
    Conversation()

    toast
      .success('Your Ticket Generate Sucessfully')
      .then(result => console.log(result))
    toast
      .error('Something Went Wrong')
      .catch(error => console.log('error', error))
  }

  // change theme 
  const theme = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme === 'light' ? '#d3e2fc' : 'black',
    color: theme === 'light' ? 'black' : '#fff',

  };

  return (
    <div>
      <div className='leftContainer bgbox' >
        <div >

          {/* game card   */}
          {isLoading ? (
            <div className='text-center'>
              <div className='loaderReturn' style={{ zIndex: '99' }}>
                <img
                  src={'/images/LandingPage_img/loader1.gif'}
                  style={{ width: '100%' }}
                />
              </div>
              {/* Add any loading spinner or animation here */}
            </div>
          ) : game && game?.length == 0 ? (
            <div className='text-center not_found_box_main'>
              <img
                src='./images/not-found.gif'
                alt='no data'
              />
              <div className='mt-2'>
                <h3 className='font-weight-bold'>No Game History</h3>
                <p>You have no game history yet.</p>
              </div>
            </div>
          ) : (
            game &&
            game.map(card => (
              <>
                <div className="game-card-split-banner">

                  {/* 1. HEADER STATUS BANNER (LOGIC SAME) */}
                  <div
                    className={`status-header-banner ${card?.Status === "completed"
                      ? card?.Winner && card?.Winner?._id === user._id
                        ? "status-win"
                        : "status-loss"
                      : "status-pending"
                      }`}
                  >
                    <b className="status-text">
                      {card?.Status === "completed"
                        ? card.Winner && card?.Winner?._id === user._id
                          ? "WINNER"
                          : "LOSER"
                        : card?.Status.toUpperCase()}
                    </b>
                  </div>

                  {/* 2. BODY CONTENT */}
                  <div className="card-body-content">

                    {/* LEFT SIDE (Game info) */}
                    <div className="details-left-column">


                      {/* Room Code */}
                      <p className="detail-label room-code-val">Room: {card?.Room_code}</p>

                      {/* Game Amount (LOGIC SAME) */}
                      <p className="detail-label game-amount-val">
                        Game is{" "}
                        {card?.Status === "completed"
                          ? card?.Winner && card?.Winner?._id === user._id
                            ? "Win"
                            : "Loss"
                          : card?.Status}{" "}
                        of:
                        <span className="value-emphasized">₹{card?.Game_Ammount}</span>
                      </p>

                      {/* Status Badge (same your logic) */}
                      {/* <span
                        className={`btn-bg text-white ${card.Status === "completed"
                            ? card.Winner && card.Winner._id === user._id
                              ? "btn-success"
                              : "btn-danger"
                            : "btn-warning"
                          }`}
                      >
                        <b>
                          {card.Status === "completed"
                            ? card.Winner && card.Winner._id === user._id
                              ? "Win"
                              : "Loss"
                            : card.Status}
                        </b>
                      </span> */}

                    </div>

                    {/* RIGHT SIDE (Financial outcomes) */}
                    <div className="details-right-column">

                      {/* Win Amount */}
                      <p className="detail-label win-amount-val">
                        Win Amount:
                        <span className="value-emphasized-green">₹{card?.winnAmount}</span>
                      </p>

                      {/* Closing Bal (LOGIC EXACT SAME) */}
                      <p className="detail-label closing-bal-val">
                        Cl Bal:
                        <span className="value-emphasized-secondary">
                          {(card?.Acceptor_status == "cancelled" &&
                            card?.Accepetd_By?.id === user.id) ? (
                            card?.Winner_closingbalance
                          ) : card?.Creator_Status == "cancelled" ? (
                            card?.Loser_closingbalance
                          ) : card?.Winner?.id === user._id ? (
                            card?.Winner_closingbalance
                          ) : (
                            card?.Loser_closingbalance
                          )}
                        </span>
                      </p>
                    </div>
                  </div>

                  {/* SEPARATOR */}
                  <hr className="card-separator" />

                  {/* 3. FOOTER DATE */}
                  <div className="card-footer-date">
                    <span className="icon-date">📅</span>
                    <p className="date-info-line">
                      {dateFormat(card?.createdAt).split(",")[0]}
                      <span className="time-info-line">
                        @{dateFormat(card?.createdAt).split(",")[1]}
                      </span>
                    </p>
                  </div>

                </div>


              </>
            ))
          )}
        </div>
      </div>

      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </div>
  )
}

export default Gamehistory
